import { Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../config/AppContext';
import './style/SelectPlanCard.scss';
import { ReactComponent as Tick } from '../../assets/subscription/TickIcon.svg'
import CommonUtil from '../../util/CommonUtils';

const SelectPlanCard = ({ toggle, setToggle, maxWidth = "0" }) => {
    const { mode } = useContext(AppContext);
    const { t } = useTranslation();

    return (
        <div
            className="selectplan-card-main"
            style={{
                background: mode === "dark" ? "#333333" : "#FFFFFF",
                maxWidth: maxWidth
            }}
        >
            <div className='card-toggle-container'
                style={{
                    borderColor: mode === "dark" ? "#EAEBEF" : "#F4F5F8",
                }}>
                <Typography
                    style={{
                        fontFamily: "GothamMedium",
                        color: toggle === "months" ? mode === "dark" ? "#f8f8f8cc" : "#242424" :
                            mode === "light" ? "rgba(36, 36, 36, 0.3)" : "rgba(248, 248, 248, 0.3)",
                            paddingTop: CommonUtil.getOS() === "MacOS" ? "5px" : "0px"
                    }}
                >{t("RAL0792")}</Typography>
                <div className="card-toggle-switch" onClick={(e) => setToggle(prev => prev === "months" ? "years" : "months")}>
                    <input type="checkbox" checked={toggle === "years" ? true : false} />
                    <span className="slider"></span>
                </div>
                <Typography
                    style={{
                        fontFamily: "GothamMedium",
                        color: toggle === "years" ? mode === "dark" ? "#f8f8f8cc" : "#242424" :
                            mode === "light" ? "rgba(36, 36, 36, 0.3)" : "rgba(248, 248, 248, 0.3)",
                            paddingTop: CommonUtil.getOS() === "MacOS" ? "5px" : "0px"
                    }}
                >{t("RAL0793")}</Typography>
            </div>
            <div>
                <Typography className='card-content-title'
                    sx={{
                        color: mode === "dark" ? "#f8f8f8cc" : "#242424"
                    }}
                >{t("RAL0831")}</Typography>
                <br />
                <Typography className='card-content-text'
                    sx={{
                        color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                        opacity: "80%"
                    }}
                >{t("RAL0832")}</Typography>
            </div>

        </div>
    );
};

export default SelectPlanCard;

